const allRouters = [
  {
    // title: "首页",
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/dashboard",
    meta: {
      title: "label_title_home",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "dashboard",
        component: () => import("@/views/Dashboard/Dashboard.vue"),
        name: "dashboard",
        meta: {
          title: "label_title_home",
          icon: "mdi-translate",
        },
      },
    ],
  },
  // 数据字典管理
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/dictionary",
    meta: {
      title: "label_title_data_dictionary",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "dictionary",
        component: () => import("@/views/dataDict/index.vue"),
        name: "dictList",
        meta: {
          title: "label_title_data_dictionary",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "add",
            component: () => import("@/views/dataDict/add/index.vue"),
            name: "add-dictionary",
            hidden: true,
            meta: {
              title: "label_newDictionary",
              icon: "mdi-translate",
            },
          },
          {
            path: "detail",
            component: () => import("@/views/dataDict/detail/index.vue"),
            name: "detail-dictionary",
            hidden: true,
            meta: {
              title: "label_view_data_dictionary",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  // 高级参照管理
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/reference",
    meta: {
      title: "label_title_advanced_referencesv",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "reference",
        component: () => import("@/views/advanceReferTo/index.vue"),
        name: "referToList",
        meta: {
          title: "label_title_advanced_referencesv",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "add",
            component: () => import("@/views/advanceReferTo/add/index.vue"),
            name: "add-reference",
            hidden: true,
            meta: {
              title: "label_newAdvance",
              icon: "mdi-translate",
            },
          },
          {
            path: "detail",
            component: () => import("@/views/advanceReferTo/detail/index.vue"),
            name: "detail-reference",
            hidden: true,
            meta: {
              title: "label_view_advanced_referencesv",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  // 客户参数配置
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/custom-param-config",
    meta: {
      title: "客户参数配置",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "custom-param-config",
        component: () => import("@/views/customParamConfig/index.vue"),
        name: "customParamConfig",
        meta: {
          title: "客户参数配置",
          icon: "mdi-translate",
        },
      },
      {
        path: "custom-param-config/add",
        component: () => import("@/views/customParamConfig/add.vue"),
        name: "customParamConfigAdd",
        meta: {
          title: "新增客户参数配置",
          icon: "mdi-translate",
        },
      },
    ],
  },
  // 成本中心
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/cost-center",
    meta: {
      title: "label_title_cost_center",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "cost-center",
        component: () => import("@/views/cost-center/index.vue"),
        name: "cost-center",
        meta: {
          title: "label_title_cost_center",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "add",
            component: () => import("@/views/cost-center/add.vue"),
            name: "add-cost-center",
            hidden: true,
            meta: {
              title: "label_addCostCenter",
              icon: "mdi-translate",
            },
          },
          {
            path: "detail",
            component: () => import("@/views/cost-center/detail.vue"),
            name: "detail-cost-center",
            hidden: true,
            meta: {
              title: "label_view_cost_center",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/module-function",
    meta: {
      title: "label_title_module_functions",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "module-function",
        component: () => import("@/views/module_func_manage/index.vue"),
        name: "module_func_manage",
        meta: {
          title: "label_title_module_functions",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "product-detail",
            component: () =>
              import("@/views/module_func_manage/product_detail/index.vue"),
            name: "product_detail",
            hidden: true,
            meta: {
              title: "产品",
              icon: "mdi-translate",
            },
          },
          {
            path: "function-detail",
            component: () =>
              import("@/views/module_func_manage/func_detail/index.vue"),
            name: "func_detail",
            hidden: true,
            meta: {
              title: "label_view_module_functions",
              icon: "mdi-translate",
            },
          },
          {
            path: "function-add",
            component: () =>
              import("@/views/module_func_manage/add_func/index.vue"),
            name: "add_func",
            hidden: true,
            meta: {
              title: "label_addFunction",
              icon: "mdi-translate",
            },
          },
          {
            path: "module-add",
            component: () =>
              import("@/views/module_func_manage/module_detail/add.vue"),
            name: "module_add",
            hidden: true,
            meta: {
              title: "label_addModule",
              icon: "mdi-translate",
            },
          },
          {
            path: "module-detail",
            component: () =>
              import("@/views/module_func_manage/module_detail/detail.vue"),
            name: "module_detail",
            hidden: true,
            meta: {
              title: "label_view_module_functions",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  // 菜单管理
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/menu",
    meta: {
      title: "label_title_menu",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "menu",
        component: () => import("@/views/menu_manage/index.vue"),
        name: "menu_manage",
        meta: {
          title: "label_title_menu",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "add",
            component: () => import("@/views/menu_manage/add/index.vue"),
            name: "menu_add",
            hidden: true,
            meta: {
              title: "label_addMenu",
              icon: "mdi-translate",
            },
          },
          {
            path: "detail",
            component: () => import("@/views/menu_manage/detail/index.vue"),
            name: "menu_detail",
            hidden: true,
            meta: {
              title: "label_view_menu",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },

  // 客户管理
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/client",
    meta: {
      title: "label_title_customers",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "client",
        component: () => import("@/views/clientmanage/index.vue"),
        name: "clientmanage",
        // redirect: 'clientmanage/clientdetail',
        meta: {
          title: "label_title_customers",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import("@/views/clientmanage/clientdetail/index.vue"),
            name: "clientdetail",
            hidden: true,
            meta: {
              title: "label_view_customers",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () => import("@/views/clientmanage/addnewuser.vue"),
            name: "addnewuser",
            hidden: true,
            meta: {
              title: "label_addClient",
              icon: "mdi-translate",
            },
          },
          {
            path: "copy",
            component: () => import("@/views/clientmanage/addcopyuser.vue"),
            name: "addcopyuser",
            hidden: true,
            meta: {
              title: "label_addCopyClient",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  // 版本管理
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/version",
    meta: {
      title: "label_title_version",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "version",
        component: () =>
          import("@/views/internationalization/version/index.vue"),
        name: "version",
        meta: {
          title: "label_title_version",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import("@/views/internationalization/version/detail.vue"),
            name: "detailVersion",
            hidden: true,
            meta: {
              title: "label_view_version",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () =>
              import("@/views/internationalization/version/add.vue"),
            name: "addVersion",
            hidden: true,
            meta: {
              title: "label_addVersion",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },

  // 国际化
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/label-internationalization",
    meta: {
      title: "label_title_basic_internationalization_data",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "label-internationalization",
        name: "internationIndex",
        component: () => import("@/views/internationalization/index.vue"),
        meta: {
          title: "label_title_basic_internationalization_data",
          icon: "",
        },
        children: [
          {
            path: "list",
            component: () =>
              import("@/views/internationalization/allClientMsg/index.vue"),
            name: "allClientMsg",
            hidden: true,
            meta: {
              title: "label_Internationalization_basic_data_list",
              icon: "mdi-translate",
            },
            children: [
              {
                path: "detail",
                component: () =>
                  import(
                    "@/views/internationalization/allClientMsg/detailAllClientMsg.vue"
                  ),
                name: "detailAllClientMsg",
                hidden: true,
                meta: {
                  title: "label_view_basic_internationalization_data",
                  icon: "mdi-translate",
                },
              },
              {
                path: "add",
                component: () =>
                  import(
                    "@/views/internationalization/allClientMsg/addAllClientMsg.vue"
                  ),
                name: "addAllClientMsg",
                hidden: true,
                meta: {
                  title: "label_addInternationalData",
                  icon: "mdi-translate",
                },
              },
              {
                path: "translate",
                component: () =>
                  import(
                    "@/views/internationalization/labelInttranslation/detaillabelInttranslation.vue"
                  ),
                name: "detaillabelInttranslation",
                hidden: true,
                meta: {
                  title: "label_view_translation",
                  icon: "mdi-translate",
                },
              },
            ],
          },
        ],
      },
    ],
  },
  // {
  //     path: "/",
  //     component: () =>
  //         import ('@/LAYOUT/index.vue'),
  //     redirect: '/client-internationalization',
  //     meta: {
  //         title: "客户端国际化",
  //         icon: "mdi-translate"
  //     },
  //     children: [{
  //         path: "client-internationalization",
  //         component: () =>
  //             import ("@/views/internationalization/client-internationalization/index.vue"),
  //         name: "clientInternationalization",
  //         // redirect: 'internationalization/clientdetail',
  //         meta: {
  //             title: "客户端国际化",
  //             icon: "mdi-translate"
  //         },
  //         children: [{
  //             path: "detail",
  //             component: () =>
  //                 import ("@/views/internationalization/client-internationalization/detail.vue"),
  //             name: "detailClientInternationalization",
  //             hidden: true,
  //             meta: {
  //                 title: "详情",
  //                 icon: "mdi-translate"
  //             }
  //         }]
  //     }, ]
  // },
  // value國際化配置
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/value-internationalization",
    meta: {
      title: "label_title_value_internationalization",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "value-internationalization",
        component: () =>
          import("@/views/internationalization/valueIntconfig/index.vue"),
        name: "valueIntconfig",
        // redirect: 'internationalization/clientdetail',
        meta: {
          title: "label_title_value_internationalization",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import(
                "@/views/internationalization/valueIntconfig/detailvalueIntconfig.vue"
              ),
            name: "detailvalueIntconfig",
            hidden: true,
            meta: {
              title: "label_view value internationalization",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },

  // 企业设置
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/organization",
    meta: {
      title: "label_title_corporate_settings",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "organization",
        component: () => import("@/views/enterprise/index.vue"),
        name: "enterprise",
        meta: {
          title: "label_title_corporate_settings",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import("@/views/enterprise/enterpriseInfo/index.vue"),
            name: "enterpriseInfo",
            hidden: true,
            meta: {
              title: "label_view_corporate_settings",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () => import("@/views/enterprise/addCompany/index.vue"),
            name: "addCompany",
            hidden: true,
            meta: {
              title: "label_addEnterprise",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },

  // 角色管理

  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/role",
    meta: {
      title: "label_title_role_management",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "role",
        component: () => import("@/views/role/index.vue"),
        name: "role",
        meta: {
          title: "label_title_role_management",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () => import("@/views/role/roleInfo/index.vue"),
            name: "roleInfo",
            hidden: true,
            meta: {
              title: "label_view_role_management",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () => import("@/views/role/addRole/index.vue"),
            name: "addRole",
            hidden: true,
            meta: {
              title: "label_addRole",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  //系统日志
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/system-log",
    meta: {
      title: "label_system_log",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "system-log",
        component: () => import("@/views/system_log/index.vue"),
        name: "system-log",
        meta: {
          title: "label_system_log",
          icon: "mdi-translate",
        }
      },
    ],
  },
  // 文档管理or目录管理
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/directory-management",
    meta: {
      title: "label_document_management",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "directory-management",
        component: () => import("@/views/directory_management/index.vue"),
        name: "directory-management",
        meta: {
          title: "label_document_management",
          icon: "mdi-translate",
        },
        children: [
        ],
      },
      {//静态资源管理
        path: "static-Resource",
        component: () => import("@/views/staticResourceConfig/index.vue"),
        name: "staticResource",
        meta: {
          title: "静态资源管理",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import(
                "@/views/staticResourceConfig/detail.vue"
              ),
            name: "detailStaticResource",
            hidden: true,
            meta: {
              title: "label_viewStaffPropertyGroup",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () =>
              import(
                "@/views/staticResourceConfig/add.vue"
              ),
            name: "addStaticResource",
            hidden: true,
            meta: {
              title: "label_addStaffPropertyGroup",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  // 流水号管理
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/serial-number",
    meta: {
      title: "label_title_serial_number",
      icon: "mdi-translate",
    },
    children: [
      {
        //label_title_serial_number
        path: "serial-number",
        component: () => import("@/views/serial-number/index.vue"),
        name: "serial-number",
        meta: {
          title: "label_title_serial_number",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () => import("@/views/serial-number/detail.vue"),
            name: "detailSerialNumber",
            hidden: true,
            meta: {
              title: "label_view_serial_number",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () => import("@/views/serial-number/add.vue"),
            name: "addSerialNumber",
            hidden: true,
            meta: {
              title: "label_addSerialNumber",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  //员工管理
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/staff",
    meta: {
      title: "员工管理",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "staff",
        component: () => import("@/views/staffmanagement/staffs_msg/index.vue"),
        name: "staffmanagement",
        meta: {
          title: "label_title_employee_information",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import(
                "@/views/staffmanagement/staffs_msg/detailstaffmanagement.vue"
              ),
            name: "detailstaffmanagement",
            hidden: true,
            meta: {
              title: "label_view_employee_information",
              icon: "mdi-translate",
            },
          },
        ],
      },
      {
        path: "staff-add",
        component: () =>
          import("@/views/staffmanagement/addstaff/addstaff.vue"),
        name: "addstaff",
        meta: {
          title: "label_addStaff",
          icon: "mdi-translate",
        },
      },
      //员工属性组
      {
        path: "staff-property-group",
        component: () =>
          import(
            "@/views/staffmanagement/staffPropertyGroup/staffPropertyGroup.vue"
          ),
        name: "staffPropertyGroup",
        meta: {
          title: "label_title_StaffPropertyGroup",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import(
                "@/views/staffmanagement/staffPropertyGroup/detailstaffPropertyGroup.vue"
              ),
            name: "detailstaffPropertyGroup",
            hidden: true,
            meta: {
              title: "label_viewStaffPropertyGroup",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () =>
              import(
                "@/views/staffmanagement/staffPropertyGroup/addstaffPropertyGroup.vue"
              ),
            name: "addstaffPropertyGroup",
            hidden: true,
            meta: {
              title: "label_addStaffPropertyGroup",
              icon: "mdi-translate",
            },
          },
        ],
      },
      // {
      //   //文档
      //   path: "file",
      //   component: () => import("@/views/document_management/file/index.vue"),
      //   name: "file",
      //   meta: {
      //     title: "文档",
      //     icon: "mdi-translate",
      //   },
      //   children: [
      //     {
      //       path: "addFile",
      //       component: () =>
      //         import("@/views/document_management/file/addFile/index.vue"),
      //       name: "addFile",
      //       hidden: true,
      //       meta: {
      //         title: "label_001-018_001-017-003_addFile",
      //         icon: "mdi-translate",
      //       },
      //     },
      //     {
      //       path: "detail",
      //       component: () =>
      //         import("@/views/document_management/file/fileInfo/index.vue"),
      //       name: "fileInfo",
      //       hidden: true,
      //       meta: {
      //         title: "label_001-018_001-017-003_viewFile",
      //         icon: "mdi-translate",
      //       },
      //     },
      //   ],
      // },
      // {
      //   //個人文档
      //   path: "personalFiles",
      //   component: () =>
      //     import("@/views/document_management/personalFiles/index.vue"),
      //   name: "personalFiles",
      //   meta: {
      //     title: "个人文档",
      //     icon: "mdi-translate",
      //   },
      //   children: [
      //     {
      //       path: "addFile",
      //       component: () =>
      //         import(
      //           "@/views/document_management/personalFiles/addFile/index.vue"
      //         ),
      //       name: "addFile",
      //       hidden: true,
      //       meta: {
      //         title: "label_001-018_001-017-003_addFile",
      //         icon: "mdi-translate",
      //       },
      //     },
      //     {
      //       path: "detail",
      //       component: () =>
      //         import(
      //           "@/views/document_management/personalFiles/fileInfo/index.vue"
      //         ),
      //       name: "fileInfo",
      //       hidden: true,
      //       meta: {
      //         title: "label_001-018_001-017-003_viewFile",
      //         icon: "mdi-translate",
      //       },
      //     },
      //   ],
      // },
      // {
      //   //文档目录
      //   path: "File-directory",
      //   component: () =>
      //     import("@/views/document_management/fileDirectory/index.vue"),
      //   name: "fileFirectory",
      //   meta: {
      //     title: "文件目录授权",
      //     icon: "mdi-translate",
      //   },
      //   children: [
      //     {
      //       path: "add-file-directory",
      //       component: () =>
      //         import("@/views/document_management/fileDirectory/add/index.vue"),
      //       name: "addFileDirectory",
      //       hidden: true,
      //       meta: {
      //         title: "新增文件目录",
      //         icon: "mdi-translate",
      //       },
      //     },
      //     {
      //       path: "detail",
      //       component: () =>
      //         import("@/views/document_management/file/fileInfo/index.vue"),
      //       name: "fileInfo",
      //       hidden: true,
      //       meta: {
      //         title: "label_001-018_001-017-003_viewFile",
      //         icon: "mdi-translate",
      //       },
      //     },
      //   ],
      // },
      {
        //员工类型
        path: "staff-type",
        component: () =>
          import("@/views/staffmanagement/staffType/index.vue"),
        name: "staffType",
        meta: {
          title: "员工类型",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import(
                "@/views/staffmanagement/staffType/detail.vue"
              ),
            name: "detailStaffType",
            hidden: true,
            meta: {
              title: "label_edit_staff_type",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () =>
              import(
                "@/views/staffmanagement/staffType/add.vue"
              ),
            name: "addStaffType",
            hidden: true,
            meta: {
              title: "label_add_staff_type",
              icon: "mdi-translate",
            },
          },
        ],
      },
      {
        //员工等级
        path: "staff-grade",
        component: () =>
          import("@/views/staffmanagement/staffGrade/index.vue"),
        name: "staffGrade",
        meta: {
          title: "员工等级",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import(
                "@/views/staffmanagement/staffGrade/detail.vue"
              ),
            name: "detailStaffGrade",
            hidden: true,
            meta: {
              title: "label_view_staff_grade",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () =>
              import(
                "@/views/staffmanagement/staffGrade/add.vue"
              ),
            name: "addStaffGrade",
            hidden: true,
            meta: {
              title: "label_add_staff_grade",
              icon: "mdi-translate",
            },
          },
        ],
      },
      {
        //员工关系 
        path: "staff-relation",
        component: () =>
          import("@/views/staffmanagement/staffRelation/index.vue"),
        name: "staffRelation",
        meta: {
          title: "员工关系",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import(
                "@/views/staffmanagement/staffRelation/detail.vue"
              ),
            name: "detailStaffRelation",
            hidden: true,
            meta: {
              title: "label_view_staff_correlation",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () =>
              import(
                "@/views/staffmanagement/staffRelation/add.vue"
              ),
            name: "addStaffRelation",
            hidden: true,
            meta: {
              title: "label_add_staff_correlation",
              icon: "mdi-translate",
            },
          },
        ],
      },
      {
        //员工关系配置
        path: "staff-relation-config",
        component: () =>
          import("@/views/staffmanagement/staffRelationConfig/index.vue"),
        name: "staffRelationConfig",
        meta: {
          title: "员工关系配置",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import(
                "@/views/staffmanagement/staffRelationConfig/detail.vue"
              ),
            name: "detailStaffRelationConfig",
            hidden: true,
            meta: {
              title: "label_view_staff_correlation_config",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () =>
              import(
                "@/views/staffmanagement/staffRelationConfig/add.vue"
              ),
            name: "addStaffRelationConfig",
            hidden: true,
            meta: {
              title: "label_add_staff_correlation_config",
              icon: "mdi-translate",
            },
          },
        ],
      },
      {
        //员工变更管理
        path: "staff-movement",
        component: () =>
          import("@/views/staffmanagement/staffVariation/index.vue"),
        name: "staffVariation",
        meta: {
          title: "label_title_employee_change",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import(
                "@/views/staffmanagement/staffVariation/detailStaffVariation.vue"
              ),
            name: "detailStaffVariation",
            hidden: true,
            meta: {
              title: "label_view_employee_change",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () =>
              import(
                "@/views/staffmanagement/staffVariation/addStaffVariation.vue"
              ),
            name: "addStaffVariation",
            hidden: true,
            meta: {
              title: "label_addStaffMovement",
              icon: "mdi-translate",
            },
          },
        ],
      },

      {
        //员工离职管理
        path: "staff-termination",
        component: () => import("@/views/staffmanagement/staffLeave/index.vue"),
        name: "staffLeave",
        meta: {
          title: "label_title_employee_resignation",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import("@/views/staffmanagement/staffLeave/detailStaffLeave.vue"),
            name: "detailStaffLeave",
            hidden: true,
            meta: {
              title: "label_view_employee_resignation",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () =>
              import("@/views/staffmanagement/staffLeave/addStaffLeave.vue"),
            name: "addStaffLeave",
            hidden: true,
            meta: {
              title: "label_addStaffTermination",
              icon: "mdi-translate",
            },
          },
        ],
      },

      // 员工离职交接
      {
        path: "staff-handover",
        component: () =>
          import("@/views/staffmanagement/staffConnect/index.vue"),
        name: "staffConnect",
        meta: {
          title: "label_title_employee_resignation_and_transfer",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import(
                "@/views/staffmanagement/staffConnect/detailStaffConnect.vue"
              ),
            name: "detailStaffConnect",
            hidden: true,
            meta: {
              title: "label_view_employee_resignation_and_transfer",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () =>
              import(
                "@/views/staffmanagement/staffConnect/addStaffConnect.vue"
              ),
            name: "addStaffConnect",
            hidden: true,
            meta: {
              title: "label_addStaffHandover",
              icon: "mdi-translate",
            },
          },
        ],
      },

      {
        //员工转正
        path: "staff-promotion",
        component: () =>
          import("@/views/staffmanagement/staffOfficial/index.vue"),
        name: "staffOfficial",
        meta: {
          title: "label_title_employee_conversion",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import(
                "@/views/staffmanagement/staffOfficial/detailStaffOfficial.vue"
              ),
            name: "detailStaffOfficial",
            hidden: true,
            meta: {
              title: "label_view_employee_conversion",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () =>
              import(
                "@/views/staffmanagement/staffOfficial/addStaffOfficial.vue"
              ),
            name: "addStaffOfficial",
            hidden: true,
            meta: {
              title: "label_addStaffPromotion",
              icon: "mdi-translate",
            },
          },
        ],
      },

      {
        //员工群组管理
        path: "staff-group",
        component: () => import("@/views/staffmanagement/staffGroup/index.vue"),
        name: "staffGroup",
        meta: {
          title: "label_title_employee_groups",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import("@/views/staffmanagement/staffGroup/detailStaffGroup.vue"),
            name: "detailStaffGroup",
            hidden: true,
            meta: {
              title: "label_view_employee_groups",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () =>
              import("@/views/staffmanagement/staffGroup/addStaffGroup.vue"),
            name: "addStaffGroup",
            hidden: true,
            meta: {
              title: "label_addStaffGroup",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  //组织架构
  // alwaysShow: false,
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/organization-structure",
    meta: {
      title: "组织框架管理",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "organization-structure",
        component: () =>
          import("@/views/o_f_manage/department_manage/index.vue"),
        name: "department_manage",
        meta: {
          title: "label_title_department",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "level",
            component: () =>
              import(
                "@/views/o_f_manage/department_manage/department_list/index.vue"
              ),
            name: "department_list",
            meta: {
              title: "label_department_list",
              icon: "mdi-translate",
            },
            hidden: true,
            children: [
              {
                path: "detail",
                component: () =>
                  import(
                    "@/views/o_f_manage/department_manage/detail/index.vue"
                  ),
                name: "department_detail",
                meta: {
                  title: "label_view_department",
                  icon: "mdi-translate",
                },
                hidden: true,
              },
              {
                path: "add",
                component: () =>
                  import("@/views/o_f_manage/department_manage/add/index.vue"),
                name: "department_add",
                meta: {
                  title: "label_addDepartment",
                  icon: "mdi-translate",
                },
                hidden: true,
              },
            ],
          },
        ],
      },
      // 岗位管理
      {
        path: "job-position",
        component: () => import("@/views/o_f_manage/jobs_manage/index.vue"),
        name: "jobs_manage",
        meta: {
          title: "label_title_posts",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "add",
            component: () =>
              import(
                "@/views/o_f_manage/jobs_manage/newpositions/newpositions.vue"
              ),
            name: "new_positions",
            meta: {
              title: "label_addJobs",
              icon: "mdi-translate",
            },
            hidden: true,
          },
          {
            path: "detail",
            component: () =>
              import(
                "@/views/o_f_manage/jobs_manage/newpositions/detailpositions.vue"
              ),
            name: "detail_positions",
            meta: {
              title: "label_view_posts",
              icon: "mdi-translate",
            },
            hidden: true,
          },
        ],
      },
      //岗位等级管理
      {
        path: "job-position-level",
        component: () =>
          import("@/views/o_f_manage/Post_level_management/index.vue"),
        name: "Post_level_management",
        meta: {
          title: "label_title_job_level",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import("@/views/o_f_manage/Post_level_management/detailPost.vue"),
            name: "detailPost",
            meta: {
              title: "label_view_job_level",
              icon: "mdi-translate",
            },
            hidden: true,
          },
          {
            path: "add",
            component: () =>
              import("@/views/o_f_manage/Post_level_management/addOne.vue"),
            name: "addOne",
            meta: {
              title: "label_addJobPositionLevelOne",
              icon: "mdi-translate",
            },
            hidden: true,
          },
          {
            path: "add-group",
            component: () =>
              import("@/views/o_f_manage/Post_level_management/addGroup.vue"),
            name: "addGroup",
            meta: {
              title: "label_addJobPositionLevelGroup",
              icon: "mdi-translate",
            },
            hidden: true,
          },
        ],
      },
      // 组织架构变动管理
      {
        path: "organizational-change-management",
        component: () =>
          import("@/views/o_f_manage/organizationalManagement/index.vue"),
        name: "organizationalManagement",
        meta: {
          title: "label_title_organizational_changes",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import(
                "@/views/o_f_manage/organizationalManagement/detailOrganizationalManagement.vue"
              ),
            name: "detailOrganizationalManagement",
            meta: {
              title: "label_view_organizational_changes",
              icon: "mdi-translate",
            },
            hidden: true,
          },
          {
            path: "add",
            component: () =>
              import(
                "@/views/o_f_manage/organizationalManagement/addOrganizationalManagement.vue"
              ),
            name: "addOrganizationalManagement",
            meta: {
              title: "label_addOrganizationalChange",
              icon: "mdi-translate",
            },
            hidden: true,
          },
        ],
      },
      // {
      //   path: "detail",
      //   component: () => import("@/views/o_f_manage/organizationalManagement/detailOrganizationalManagement.vue"),
      //   name: "detailOrganizationalManagement",
      //   meta: {
      //     title: "详情",
      //     icon: "mdi-translate"
      //   },
      //   hidden: true
      // },
      // {
      //   path: "add",
      //   component: () => import("@/views/o_f_manage/organizationalManagement/addOrganizationalManagement.vue"),
      //   name: "addOrganizationalManagement",
      //   meta: {
      //     title: "新组织架构变动",
      //     icon: "mdi-translate"
      //   },
      //   hidden: true
      // }
    ],
  },
  {
    // 密码设置
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/super-admin-password-strength",
    meta: {
      title: "label_title_password_setting",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "super-admin-password-strength",
        component: () => import("@/views/passwordIntensity/index.vue"),
        name: "passwordIntensity",
        meta: {
          title: "label_title_password_setting",
          icon: "mdi-translate",
        },
      },
      {
        path: "super-admin-password-strength/edit",
        component: () =>
          import("@/views/passwordIntensity/passwordIntensity.vue"),
        name: "detailPasswordIntensity",
        hidden: true,
        meta: {
          title: "label_password_setting",
          icon: "mdi-translate",
        },
      },
    ],
  },
  //审批业务类型
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/approve-on-behalf",
    meta: {
      title: "label_title_approval_business_type",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "approve-business-type",
        component: () => import("@/views/approvertype/index.vue"),
        name: "approvertype",
        meta: {
          title: "label_title_approval_business_type",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "edit",
            component: () => import("@/views/approvertype/detail.vue"),
            name: "detailApprovertype",
            hidden: true,
            meta: {
              title: "label_view_approval_business_type",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () => import("@/views/approvertype/add.vue"),
            name: "addApprovertype",
            hidden: true,
            meta: {
              title: "label_new_approval_business_type",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  //审批代理
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/approve-on-behalf",
    meta: {
      title: "label_title_approval_agent",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "approve-on-behalf",
        component: () => import("@/views/approver/index.vue"),
        name: "approver",
        meta: {
          title: "label_title_approval_agent",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "edit",
            component: () => import("@/views/approver/detailApprover.vue"),
            name: "detailApprover",
            hidden: true,
            meta: {
              title: "label_view_approval_agent",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () => import("@/views/approver/addApprover.vue"),
            name: "addApprover",
            hidden: true,
            meta: {
              title: "label_addApprover",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  //申请代理配置
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/apply-on-behalf",
    meta: {
      title: "label_title_application_agent",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "apply-on-behalf",
        component: () => import("@/views/businessApply/index.vue"),
        name: "businessApply",
        meta: {
          title: "label_title_application_agent",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "edit",
            component: () =>
              import("@/views/businessApply/detailBusinessApply.vue"),
            name: "detailBusinessApply",
            hidden: true,
            meta: {
              title: "label_view_application_agent",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () =>
              import("@/views/businessApply/addBusinessApply.vue"),
            name: "addBusinessApply",
            hidden: true,
            meta: {
              title: "label_addBusinessApply",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  // 邮件模板
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/email-template",
    meta: {
      title: "label_title_email_template",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "email-template",
        component: () => import("@/views/emailtemplate/index.vue"),
        name: "emailtemplate",
        meta: {
          title: "label_title_email_template",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import("@/views/emailtemplate/detailemailtemplate.vue"),
            name: "detailemailtemplate",
            hidden: true,
            meta: {
              title: "label_view_email_template",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () =>
              import("@/views/emailtemplate/addemailtemplate.vue"),
            name: "addemailtemplate",
            hidden: true,
            meta: {
              title: "label_addMailTemplate",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  //系统参数
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/system-parameter",
    meta: {
      title: "label_title_system_parameters",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "system-parameter",
        component: () => import("@/views/systemParameter/index.vue"),
        name: "systemParameter",
        meta: {
          title: "label_title_system_parameters",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import("@/views/systemParameter/detailSystemParameter.vue"),
            name: "detailSystemParameter",
            hidden: true,
            meta: {
              title: "label_view_system_parameters",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () =>
              import("@/views/systemParameter/addSystemParameter.vue"),
            name: "addSystemParameter",
            hidden: true,
            meta: {
              title: "label_addSystemParameter",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  // 定时任务
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/scheduled-task",
    meta: {
      title: "label_title_scheduled_tasks",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "scheduled-task",
        component: () => import("@/views/timedTask/index.vue"),
        name: "timedTask",
        meta: {
          title: "label_title_scheduled_tasks",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () => import("@/views/timedTask/detailTimedTask.vue"),
            name: "detailTimedTask",
            hidden: true,
            meta: {
              title: "label_view_scheduled_tasks",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () => import("@/views/timedTask/addTimedTask.vue"),
            name: "addTimedTask",
            hidden: true,
            meta: {
              title: "label_addTimedTask",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  // 密码安全设置
  // {
  //   path: "/",
  //   component: () => import('@/LAYOUT/index.vue'),
  //   redirect: '/super-admin-password-strength',
  //   meta: {
  //     title: "密码安全设置",
  //     icon: "mdi-translate"
  //   },
  //   children: [
  //     {
  //       path: "super-admin-password-strength",
  //       component: () => import() "@/views/passwordSet/index.vue",
  //       name: "passwordSet",
  //       meta: {
  //         title: "密码安全设置",
  //         icon: "mdi-translate"
  //       }
  //     }
  //   ]
  // },
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/push-notification-template",
    meta: {
      title: "推送消息模板",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "push-notification-template",
        component: () => import("@/views/pushTemplate/index.vue"),
        name: "pushtemplate",
        meta: {
          title: "推送消息模板",
          icon: "mdi-translate",
        },
        // children: [
        //   {
        //     path: "detail",
        //     component: () =>
        //       import("@/views/pushTemplate/detailPushTemplate.vue"),
        //     name: "detailpushtemplate",
        //     hidden: true,
        //     meta: {
        //       title: "模板详情",
        //       icon: "mdi-translate"
        //     },
        //   },
        //   {
        //     path: "add",
        //     component: () =>
        //       import("@/views/pushTemplate/addPushTemplate.vue"),
        //     name: "addpushtemplate",
        //     hidden: true,
        //     meta: {
        //       title: "label_addPushNewsTemplate",
        //       icon: "mdi-translate"
        //     },
        //   }
        // ]
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "mail-setting",
    meta: {
      title: "邮箱设置",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "mail-setting",
        component: () => import("@/views/mailSetting/index.vue"),
        name: "mailSetting",
        meta: {
          title: "邮箱设置",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () => import("@/views/mailSetting/index.vue"),
            name: "mailSettingDetail",
            meta: {
              title: "邮箱设置详情",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  //代码逻辑配置管理
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/code-logic",
    meta: {
      title: "label_title_code_logic_configuration",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "code-logic",
        component: () => import("@/views/codeLogicManagement/index.vue"),
        name: "codeLogic",
        meta: {
          title: "label_title_code_logic_configuration",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            component: () =>
              import("@/views/codeLogicManagement/detailCodeLogic.vue"),
            name: "detailCodeLogic",
            hidden: true,
            meta: {
              title: "label_view_code_logic_configuration",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            component: () =>
              import("@/views/codeLogicManagement/addCodeLogic.vue"),
            name: "addCodeLogic",
            hidden: true,
            meta: {
              title: "label_addCodeLogic",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  //平台管理员
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/system-superdmin",
    meta: {
      title: "label_title_platform_administrator",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "system-superdmin",
        component: () => import("@/views/mrc_system_admin/index.vue"),
        name: "mrc_system_admin",
        meta: {
          title: "label_title_platform_administrator",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            name: "mrc_system_detail",
            component: () =>
              import("@/views/mrc_system_admin/detail/index.vue"),
            hidden: true,
            meta: {
              title: "label_view_platform_administrator",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            name: "mrc_system_add",
            component: () => import("@/views/mrc_system_admin/add/index.vue"),
            hidden: true,
            meta: {
              title: "label_addMrcSystemManager",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  //企业管理员
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/client-admin",
    meta: {
      title: "label_title_enterprise_administrator",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "client-admin",
        component: () => import("@/views/admin_account_manage/index.vue"),
        name: "admin_account_manage",
        meta: {
          title: "label_title_enterprise_administrator",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            name: "admin_account_detail",
            component: () =>
              import("@/views/admin_account_manage/detail/index.vue"),
            hidden: true,
            meta: {
              title: "label_view_enterprise_administrator",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            name: "admin_account_add",
            component: () =>
              import("@/views/admin_account_manage/add/index.vue"),
            hidden: true,
            meta: {
              title: "label_addManager",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  //存储过程管理
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/data-stored-procedure",
    meta: {
      title: "label_title_stored_procedure",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "data-stored-procedure",
        component: () => import("@/views/data-stored-procedure/index.vue"),
        name: "data-stored-procedure",
        meta: {
          title: "label_title_stored_procedure",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            name: "data-stored-procedure-detail",
            component: () =>
              import("@/views/data-stored-procedure/detail/index.vue"),
            hidden: true,
            meta: {
              title: "label_view_stored_procedure",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            name: "data-stored-procedure-add",
            component: () =>
              import("@/views/data-stored-procedure/add/index.vue"),
            hidden: true,
            meta: {
              title: "label_addDataStoredProcedure",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  //视图管理
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/data-view",
    meta: {
      title: "label_title_edit",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "data-view",
        component: () => import("@/views/data-view/index.vue"),
        name: "data-view",
        meta: {
          title: "label_title_edit",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            name: "data-view-detail",
            component: () => import("@/views/data-view/detail/index.vue"),
            hidden: true,
            meta: {
              title: "label_view_view",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            name: "data-view-add",
            component: () => import("@/views/data-view/add/index.vue"),
            hidden: true,
            meta: {
              title: "label_addDataView",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  //数据策略管理
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/data-access-strategy",
    meta: {
      title: "label_title_data_strategy",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "data-access-strategy",
        component: () => import("@/views/data-access-strategy/index.vue"),
        name: "data-access-strategy",
        meta: {
          title: "label_title_data_strategy",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            name: "data-access-strategy-detail",
            component: () =>
              import("@/views/data-access-strategy/detail/index.vue"),
            hidden: true,
            meta: {
              title: "label_view_data_strategy",
              icon: "mdi-translate",
            },
          },
          {
            path: "add",
            name: "data-access-strategy-add",
            component: () =>
              import("@/views/data-access-strategy/add/index.vue"),
            hidden: true,
            meta: {
              title: "label_addDataAccessStrategy",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/my-account",
    meta: {
      title: "我的账户",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "my-account",
        component: () => import("@/views/userAccount/index.vue"),
        name: "userAccount",
        meta: {
          title: "我的账户",
          icon: "mdi-translate",
        },
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/my-info",
    meta: {
      title: "个人资料",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "my-info",
        name: "userInfo",
        component: () => import("@/views/userInfo/index.vue"),
        meta: {
          title: "个人资料",
          icon: "mdi-translate",
        },
      },
    ],
  },
  //历史邮件
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/history-mail",
    meta: {
      title: "label_title_historical_mail",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "history-mail",
        name: "historyMail",
        component: () => import("@/views/historyMail/index.vue"),
        meta: {
          title: "label_title_historical_mail",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "detail",
            name: "historyMailDeatil",
            component: () =>
              import("@/views/historyMail/detailHistoryMail.vue"),
            meta: {
              title: "label_view_historical_mail",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/mrc_base_leaveApplication",
    meta: {
      title: "测试请假申请",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "mrc_base_leaveApplication",
        name: "mrc_base_leaveApplication",
        component: () => import("@/views/mrc_base_leaveApplication/index.vue"),
        meta: {
          title: "测试请假申请",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "add",
            name: "mrc_base_leaveApplication-add",
            component: () =>
              import("@/views/mrc_base_leaveApplication/add.vue"),
            meta: {
              title: "新增",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/LAYOUT/index.vue"),
    redirect: "/mrc_ess_Reimbursement",
    meta: {
      title: "测试报销申请",
      icon: "mdi-translate",
    },
    children: [
      {
        path: "mrc_ess_Reimbursement",
        name: "mrc_ess_Reimbursement",
        component: () => import("@/views/mrc_ess_Reimbursement/index.vue"),
        meta: {
          title: "测试报销申请",
          icon: "mdi-translate",
        },
        children: [
          {
            path: "add",
            name: "mrc_ess_Reimbursement-add",
            component: () => import("@/views/mrc_ess_Reimbursement/add.vue"),
            meta: {
              title: "新增",
              icon: "mdi-translate",
            },
          },
        ],
      },
    ],
  },
]
export default allRouters
